import React, { useEffect, useState } from "react";
import referentesService from "../../../../services/referentesService";
import { showToast } from "../../../../utils/showToast";

const TIPOS = ["comisionista", "externo", "estudiante", "docente", "administrativo"];
const TIPO_LABEL = { comisionista: "Comisionista", externo: "Externo", estudiante: "Estudiante", docente: "Docente", administrativo: "Administrativo" };

const EMPTY = { tipo: "comisionista", nombre: "", identificacion: "", telefono: "", email: "", observaciones: "" };

export default function ComisionistaModal({ item, onClose, onSaved }) {
  const esEdicion = !!item;
  const [form, setForm]     = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (item) {
      setForm({
        tipo:           item.tipo || "comisionista",
        nombre:         item.nombre || "",
        identificacion: item.identificacion || "",
        telefono:       item.telefono || "",
        email:          item.email || "",
        observaciones:  item.observaciones || "",
      });
    } else {
      setForm(EMPTY);
    }
  }, [item]);

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nombre.trim()) return showToast({ type: "warning", message: "El nombre es requerido." });

    const payload = {
      tipo:           form.tipo,
      nombre:         form.nombre.trim(),
      identificacion: form.identificacion.trim() || null,
      telefono:       form.telefono.trim() || null,
      email:          form.email.trim() || null,
      observaciones:  form.observaciones.trim() || null,
    };

    setSaving(true);
    try {
      if (esEdicion) {
        await referentesService.editar(item.id, payload);
        showToast({ type: "success", message: "Comisionista actualizado." });
      } else {
        await referentesService.crear(payload);
        showToast({ type: "success", message: "Comisionista creado." });
      }
      onSaved();
    } catch (err) {
      showToast({ type: "danger", message: err?.message || "Error al guardar." });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.45)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow">
          <form onSubmit={handleSubmit}>
            <div className="modal-header">
              <h5 className="modal-title">{esEdicion ? "Editar comisionista" : "Nuevo comisionista"}</h5>
              <button type="button" className="btn-close" onClick={onClose} />
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label">Tipo <span className="text-danger">*</span></label>
                  <select className="form-select" value={form.tipo} onChange={set("tipo")}>
                    {TIPOS.map((t) => <option key={t} value={t}>{TIPO_LABEL[t]}</option>)}
                  </select>
                </div>
                <div className="col-12">
                  <label className="form-label">Nombre completo <span className="text-danger">*</span></label>
                  <input type="text" className="form-control" required value={form.nombre} onChange={set("nombre")} />
                </div>
                <div className="col-6">
                  <label className="form-label">Identificación</label>
                  <input type="text" className="form-control" value={form.identificacion} onChange={set("identificacion")} />
                </div>
                <div className="col-6">
                  <label className="form-label">Teléfono</label>
                  <input type="text" className="form-control" value={form.telefono} onChange={set("telefono")} />
                </div>
                <div className="col-12">
                  <label className="form-label">Email</label>
                  <input type="email" className="form-control" value={form.email} onChange={set("email")} />
                </div>
                <div className="col-12">
                  <label className="form-label">Observaciones</label>
                  <textarea className="form-control" rows={2} value={form.observaciones} onChange={set("observaciones")} />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-outline-secondary" onClick={onClose}>Cancelar</button>
              <button type="submit" className="btn management-btn-primary" disabled={saving}>
                {saving ? "Guardando..." : esEdicion ? "Guardar cambios" : "Crear"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
